import { useSearchParams } from 'react-router-dom';
import AddImagesToHCPanel from '../panels/AddImagesToHCPanel';

function AddImagesToHC() {

  const [searchParams] = useSearchParams();
  const patient: string =searchParams.get('patientID');
  const professional: string = searchParams.get('professionalID');

  return (<AddImagesToHCPanel patient={patient} professional={professional}  />);
}

export default AddImagesToHC;
